import { IDirective, IDirectiveFactory } from "angular";

export class GtmhubMultiselect implements IDirective {
  public require = "ngModel";
  public scope = {
    multiselectData: "=",
    isMultiselectRequired: "=",
  };
  public restrict = "EA";

  public link(scope, elm, attrs, ngModel: any): void {
    const checkValidity = () => {
      if (scope.multiselectData && angular.isArray(scope.multiselectData) && scope.multiselectData.length > 0) {
        // it is valid
        ngModel.$setValidity("valid", true);
      } else if (!scope.isMultiselectRequired) {
        // it is valid
        ngModel.$setValidity("valid", true);
      } else {
        // it is invalid
        ngModel.$setValidity("valid", false);
      }
    };

    checkValidity();
    scope.$watch(
      "multiselectData",
      function () {
        checkValidity();
      },
      true
    );
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new GtmhubMultiselect();
    directive.$inject = [];

    return directive;
  }
}
